import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'blackAlpha.300',
    width: 'fit-content',
    borderRadius: 'md',
    boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
    p: '2',
    my: '1',
    mr: ['1', '2'],
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2xs',
  },
  priceTitle: {
    as: 'p',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2sx',
    mr: '1',
  },
  priceNumber: {
    color: 'white',
  },
  priceText: {
    color: 'red.500',
    mr: ['1', '2'],
    fontSize: '2xs',
    display: 'flex',
    alignItems: 'center',
  },
  priceTextIncreased: {
    color: 'beta.100',
  },
  priceIcon: {
    color: 'red.500',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    ml: '1',
  },
  priceIconIncreased: {
    color: 'beta.100',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '10',
    borderLeft: '1px solid',
    borderColor: ['transparent', null, 'whiteAlpha.200'],
    ml: '1',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    bg: '#ED8936',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
